export default __webpack_public_path__ + "static/section-1-img-2-dd133ed75c267418e8e1e854dd00e54e.png";